(function () {
	'use strict';

    angular.module("imApp").factory("consignmentPlansDeliverySettingsService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 1692,
                    parameters: parms || {}
                });
            },
            listUsers: function (parms) {
                return $ihttp.post({
                    method: 1758,
                    parameters: parms || {}
                });
            },
            listStockLocations: function (parms) {
                return $ihttp.post({
                    method: 1718,
                    parameters: parms || {}
                });
            }
		};

		return service;
	}]);
})();
